'use client'

import { cn } from '@systhemaui/next'

interface PasswordChecklistProps {
  password: string
}

interface Requirement {
  label: string
  check: (password: string) => boolean
}

const requirements: Requirement[] = [
  {
    label: 'minimum 8 karakter',
    check: (password) => password.length >= 8,
  },
  {
    label: 'legalább 1 speciális karakter',
    check: (password) => /[!@#$%^&*()\-_=+\[\]{}\\|;:'",.<>/?`~]/.test(password),
  },
  {
    label: 'kis- és nagybetűk',
    check: (password) => /[a-z]/.test(password) && /[A-Z]/.test(password),
  },
]

export default function PasswordChecklist({ password }: PasswordChecklistProps) {
  return (
    <div className="flex flex-col gap-2">
      {requirements.map((requirement) => {
        const isMet = requirement.check(password)
        return (
          <div
            key={requirement.label}
            className={cn('flex items-center gap-2', isMet ? 'text-white' : 'text-[#C79BF2]')}
          >
            {isMet ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="h-4 w-4"
              >
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="h-4 w-4"
              >
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
              </svg>
            )}
            <span className={cn('text-sm', !isMet && 'line-through')}>{requirement.label}</span>
          </div>
        )
      })}
    </div>
  )
}

export function validatePassword(password: string): boolean {
  return requirements.every((req) => req.check(password))
}
